import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import ErrorPage from '../Shared/ErrorPage';
import InterveneChats from './Chat.tsx';
import OrderSummary from '../Ecommerce/Orders/index.jsx';
import ChatSummary from './ChatSummary';
import ProductListing from '../Ecommerce/ProductListing/index.jsx';
import OrderAnalytics from './OrderAnalytics';
import Settings from './Settings';
import Profile from './Profile';
import Flow from '../Ecommerce/Flow/index.tsx';
import { useResetRecoilState } from 'recoil';
import {
  channelListAtom,
  organisationFilterAtom,
  organisationResponseAtom
} from '../../Services/_states';

const InterveneRoutes = ({ isInterveneDashboard = false }) => {
  const resetOrganisationRes = useResetRecoilState(organisationResponseAtom);
  const resetOrganisationFilter = useResetRecoilState(organisationFilterAtom);
  const resetChannelList = useResetRecoilState(channelListAtom);
  const location = useLocation();

  useEffect(() => {
    const targetRoutes = ['/r/intervene-dashboard'];
    if (targetRoutes.some(route => location.pathname.startsWith(route))) {
      resetOrganisationFilter();
      resetOrganisationRes();
      resetChannelList();
    }
  }, [location]);

  return (
    <Routes>
      {isInterveneDashboard ? (
        <>
          <Route index element={<Navigate to="active" replace />} />
          <Route path=":tab" element={<InterveneChats />} />
          <Route path="*" element={<Navigate to="active" replace />} />
        </>
      ) : (
        <>
          <Route path="/chats" element={<InterveneChats />} />
          <Route path="/orders" element={<OrderSummary />} />
          <Route path="/summary" element={<ChatSummary />} />
          <Route path="/analytics" element={<OrderAnalytics />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/listing" element={<ProductListing />} />
          <Route path="/flow" element={<Flow />} />
          <Route path="*" element={<ErrorPage />} />
        </>
      )}
    </Routes>
  );
};

export default InterveneRoutes;
